import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/topic/version"

const topicVersion = {
  topicVersionListPage(pageSize, limit, keyWord, subjectId) {
    return axios.get(pre + `/topicVersionListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          subjectId: subjectId,
        }
    });
  },

  topicVersionList(subjectId) {
    return axios.get(pre + `/topicVersionList`, {
      params:
        {
          subjectId: subjectId,
        }
    });
  },
  topicVersionInfo(id) {
    return axios.get(pre + `/topicVersionInfo`, {params: {id: id}});
  },
  topicVersionSave(params) {
    return axios.post(pre + `/topicVersionSave`, qs.stringify(params));
  },
  topicVersionDelete(id) {
    return axios.delete(pre + `/topicVersionDelete`, {params: {id: id}});
  },
}
export default topicVersion;



// WEBPACK FOOTER //
// ./src/api/topic/topicVersion.js